<div class="row">
    <label class="col-form-label d-flex" style="font-weight: bolder; font-size: x-large;">Merchant
        Dashboard</label>
        <div class="card">
            <div class="card-body">
                <div class="row align-items-end">
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchMobileNumber">Merchant Contact Number</label>
                    <input class="form-control" id="searchMobileNumber" [(ngModel)]="searchMobileNumber" type="text"
                        name="searchMobileNumber">
                </div>
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchEmailId">Merchant Email Id </label>
                    <input class="form-control" id="searchEmailId" [(ngModel)]="searchEmailId" type="email"
                        name="searchEmailId">
                </div>
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchWalletId">Merchant Wallet ID </label>
                    <input class="form-control" id="searchWalletId" [(ngModel)]="searchWalletId" type="text"
                        name="searchWalletId">
                </div>
                <div class="col-sm-3">
                    <button class="btn btn-primary w-100" (click)="search()">
                        <i class="fa fa-search"></i> Search
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<br />
<div class="row" [ngStyle]="{ 'display': displayDetails ? 'block' : 'none' }">
    <div class="card" style="border-color: aliceblue !important;">
        <div class="card-body">
            <div class="d-grid gap-2 d-flex">
                <button class="btn btn-primary" (click)="this.selectedTab=0" [class.active]="selectedTab==0"
                    type="button">Business Details</button>
                <button class="btn btn-primary" (click)="this.selectedTab=1" [class.active]="selectedTab==1"
                    type="button">Device Information</button>
                <button class="btn btn-primary" (click)="this.selectedTab=2" [class.active]="selectedTab==2"
                    type="button">Wallet Details</button>
                <button class="btn btn-primary" (click)="this.selectedTab=3" [class.active]="selectedTab==3"
                    type="button">KYC Documents</button>
                <button class="btn btn-primary" (click)="this.selectedTab=4; fetchTransactionDetails()" [class.active]="selectedTab==4"
                    type="button">Transaction Details</button>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==0 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="merchantName">Merchant Name</label>
                    <input class="form-control" readonly id="merchantName" [(ngModel)]="businessDetails.legalName"
                        type="text" name="merchantName">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="tradeName">Trade Name</label>
                    <input class="form-control" readonly id="tradeName" [(ngModel)]="businessDetails.tradeName"
                        type="text" name="tradeName">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="vatNumber">VAT Number</label>
                    <input class="form-control" readonly id="vatNumber" [(ngModel)]="businessDetails.vatNumber"
                        type="text" name="vatNumber">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="identifier">Merchant ID</label>
                    <input class="form-control" readonly id="identifier" [(ngModel)]="businessDetails.identifier"
                        type="text" name="identifier">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="parentAgent">Reseller ID</label>
                    <input class="form-control" readonly id="parentAgent"
                        [(ngModel)]="businessDetails.parentIdentifier" type="text" name="parentAgent">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="emailId">Merchant Email Address</label>
                    <input class="form-control" readonly id="emailId" [(ngModel)]="businessDetails.emailId"
                        type="text" name="emailId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="commercialLicense">Trade License Number</label>
                    <input class="form-control" readonly id="commercialLicense" [(ngModel)]="businessDetails.commercialLicense"
                        type="text" name="commercialLicense">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">Registered Contact Number</label>
                    <input class="form-control" readonly id="contactNumber" [(ngModel)]="businessDetails.contactNumber" type="text"
                        name="contactNumber">
                </div>
                <div class="col-sm-4" *ngIf="isOperationsUser">
                    <label class="col-form-label" for="registrationDate">Date of Incorporation</label>
                    <input class="form-control" readonly id="registrationDate"
                        [(ngModel)]="businessDetails.dateOfIncorporation" type="text" name="registrationDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="expiryDate">Trade License Expiry Date</label>
                    <input class="form-control" readonly id="expiryDate" [(ngModel)]="businessDetails.expiryDate"
                        type="text" name="expiryDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="registerAddress">Address</label>
                    <input class="form-control" readonly id="registerAddress"
                        [(ngModel)]="businessDetails.registerAddress" type="text" name="registerAddress">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="pincode">PO Box</label>
                    <input class="form-control" readonly id="pincode" [(ngModel)]="businessDetails.pincode"
                        type="text" name="pincode">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="city">City</label>
                    <input class="form-control" readonly id="city" [(ngModel)]="businessDetails.city"
                        type="text" name="city">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="emirate">Emirate</label>
                    <input class="form-control" readonly id="emirate" [(ngModel)]="businessDetails.emirate"
                        type="text" name="emirate">
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==1 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="appVersion">App Version</label>
                    <input class="form-control" readonly id="appVersion" [(ngModel)]="deviceDetails.appVersion"
                        type="text" name="appVersion">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="deviceType">OS Type</label>
                    <input class="form-control" readonly id="deviceType" [(ngModel)]="deviceDetails.deviceType"
                        type="text" name="deviceType">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="version">OS Version</label>
                    <input class="form-control" readonly id="version" [(ngModel)]="deviceDetails.version" type="text"
                        name="version">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="deviceId">Device ID</label>
                    <input class="form-control" readonly id="deviceId" [(ngModel)]="deviceDetails.deviceId" type="text"
                        name="deviceId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="model">Device Model</label>
                    <input class="form-control" readonly id="model" [(ngModel)]="deviceDetails.model" type="text"
                        name="model">
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==2 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletId">Wallet ID</label>
                    <input class="form-control" readonly id="walletId" [(ngModel)]="walletDetails.walletId" type="text"
                        name="walletId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletBalance">Wallet Balance</label>
                    <input class="form-control" readonly id="walletBalance" [(ngModel)]="walletDetails.walletBalance"
                        type="text" name="walletBalance">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIban">Virtual IBAN</label>
                    <input class="form-control" readonly id="virtualIban" [(ngModel)]="walletDetails.virtualIban"
                        type="text" name="virtualIban">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanStatus">Virtual IBAN Status</label>
                    <input class="form-control" readonly id="virtualIbanStatus"
                        [(ngModel)]="walletDetails.virtualIbanStatus" type="text" name="virtualIbanStatus">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanCreationDate">Virtual IBAN Creation Date</label>
                    <input class="form-control" readonly id="virtualIbanCreationDate"
                        [(ngModel)]="walletDetails.virtualIbanCreationDate" type="text" name="virtualIbanCreationDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanClosureDate">Virtual IBAN Closure Date</label>
                    <input class="form-control" readonly id="virtualIbanClosureDate"
                        [(ngModel)]="walletDetails.virtualIbanClosureDate" type="text" name="virtualIbanClosureDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletStatus">Wallet Status</label>
                    <input class="form-control" readonly id="walletStatus" [(ngModel)]="walletDetails.walletStatus"
                        type="text" name="walletStatus">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="referralCode">Referral Code</label>
                    <input class="form-control" readonly id="referralCode" [(ngModel)]="walletDetails.referralCode"
                        type="text" name="referralCode">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletCreationDate">Wallet Creation Date</label>
                    <input class="form-control" readonly id="walletCreationDate"
                        [(ngModel)]="walletDetails.walletCreationDate" type="text" name="walletCreationDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletClosureDate">Wallet Closure Date</label>
                    <input class="form-control" readonly id="walletClosureDate"
                        [(ngModel)]="walletDetails.walletClosureDate" type="text" name="walletClosureDate">
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==3 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px; min-height: 300px">
                <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
                    [enableCellTextSelection]=true [rowData]="documentList" [rowModelType]="" [rowSelection]="'single'"
                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                </ag-grid-angular>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==4 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row mb-0" style="min-height: 470px">
                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="transactionTableSelectedColumn"
                        [defaultColDef]="defaultColDef" [paginationPageSize]="pageSize"
                        [pagination]="true" [rowData]="transactionDetails" (gridReady)="onTransactionGridReady($event)"
                        [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                        style="width: 100%; height: auto;">
                    </ag-grid-angular>
                </div>
            </div>
            <div class="row mt-0">
                <div class="col-4 col-xs-4 d-flex">
                    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
                        class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                        <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
                    </select>
                    <p class="text-muted p-3"> Total Records: {{ totalRecords }}</p>
                </div>
                <div class="col-8 col-xs-8">
                    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage"
                        [boundaryLinks]="true" [collectionSize]="totalRecords" [maxSize]="5" [pageSize]="pageSize"
                        [rotate]="false" [directionLinks]="true" [ellipses]="false" size="sm"
                        class="d-flex justify-content-end align-right">
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>